import { GetServerSidePropsContext } from '@src/api/serverRequest/models';
import { IUser } from '@src/models/auth';
import { AnyType } from '@src/models/common';
import jwt from 'jwt-decode';
import { NextPageContext } from '../models/ssr';

/** Предотвращает падение функции на стороне сервера при использовании внутри API браузера */
export const ssrWrapper = <Res = AnyType, Rej = AnyType>(resolve: Res, reject: Rej) => {
  if (typeof window !== 'undefined') return resolve;

  return reject;
};

export const getSSRCookie = (ctx: NextPageContext | GetServerSidePropsContext, cookieName: string): string | null => {
  if (ctx.req?.cookies) {
    return ctx.req.cookies[cookieName] || null;
  }

  const cookie = ctx.req?.headers?.cookie;

  if (!cookie) return null;

  const cookieString = cookie.split('; ').find((c) => c.includes(`${cookieName}=`));

  if (!cookieString) return null;

  return cookieString.split('=')[1] || null;
};

/** Получаем информацию о пользователе в объекте запроса для next js */
export const getUserInfo = (
  ctx: NextPageContext | GetServerSidePropsContext,
  cookieName?: string,
): { isMobile: boolean; user: IUser | null } => {
  let user: IUser | null = null;
  const mobileWords = ['iPhone', 'Mobile', 'Android'];
  const userAgent = ctx.req?.headers['user-agent'];
  let isMobile = false;

  try {
    for (let index = 0; index < mobileWords.length; index++) {
      const result = userAgent?.includes(mobileWords[index]);
      if (result) {
        isMobile = result;
        break;
      }
    }

    if (cookieName) {
      const token = getSSRCookie(ctx, cookieName);

      if (token) {
        user = jwt(token.replace(`Bearer `, ''));
      }
    }
  } catch (error) {
    console.error(error);
  }

  return {
    isMobile,
    user,
  };
};
